// src/components/TermsOfService.js
import React from "react";

const TermsOfService = () => {
  return (
    <div style={{ padding: "40px", color: "#000", maxWidth: "800px", margin: "0 auto", background: "#fff" }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective:</strong> June 21, 2025</p>

      <p>
        Welcome to LexTrack AI. By using our services, you agree to these Terms of Service.
      </p>

      <h3>1. Acceptance of Terms</h3>
      <p>
        By accessing or using LexTrack AI, you agree to be bound by these terms and any applicable laws.
      </p>

      <h3>2. Description of Service</h3>
      <p>
        LexTrack AI provides tools to create, deploy, and manage AI agents. You are responsible for how you use and configure these tools.
      </p>

      <h3>3. User Responsibilities</h3>
      <ul>
        <li>Do not violate any laws or third-party rights</li>
        <li>No unauthorized access or abuse of the platform</li>
        <li>No uploading of malicious or illegal content</li>
      </ul>

      <h3>4. Account & Access</h3>
      <p>
        You must provide accurate info and keep your credentials secure. You're responsible for all actions under your account.
      </p>

      <h3>5. Intellectual Property</h3>
      <p>
        All content, branding, and software in LexTrack AI are owned by LexTrack AI Inc. or licensed appropriately.
      </p>

      <h3>6. Termination</h3>
      <p>
        We reserve the right to suspend or terminate access for violations of these terms.
      </p>

      <h3>7. Limitation of Liability</h3>
      <p>
        LexTrack AI is not liable for indirect damages. Maximum liability is limited to what you paid us in the last 12 months.
      </p>

      <h3>8. Changes</h3>
      <p>
        We may update these terms. Continued use means you accept the new terms.
      </p>

      <h3>9. Contact</h3>
      <p>Email us: <a href="mailto:legal@lextrackai.com">legal@lextrackai.com</a></p>
    </div>
  );
};

export default TermsOfService;
